import Utils from '../utils';

export default class GA {
  static create(source, customerId, analyticsId, userId, enabled, sampling = 1) {
    if (enabled && Math.random() < sampling) {
      if (!window.ga && window.ga !== undefined) {
        const script = document.createElement('script');
        script.text = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){" +
          '(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),' +
          'm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)' +
          "})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');";

        // ajout au body
        const nodes = document.getElementsByTagName('body');
        if (nodes && nodes.length > 0) {
          nodes[0].appendChild(script);
        } else {
          throw ('GA: body is null');
        }
      }

      // check gameconfig
      window.ga = window.ga || function () {
        (window.ga.q = window.ga.q || []).push(arguments);
      };
      window.ga.l = +new Date();
      window.ga('create', analyticsId, { cookieExpires: 60 * 60 * 12 * 28, name: 'cibler' });
      window.ga('cibler.require', 'ecommerce');
      window.ga('cibler.set', 'dimension2', userId);
      window.ga('cibler.set', 'dimension3', source);
      window.ga('cibler.set', 'dimension4', customerId);
      window.ga('cibler.set', 'dimension4', customerId);
      window.ga('cibler.send', 'pageview');
    }
  }

  static emitTrackEvent(category, action, label = null) {
    if (window.ga) {
      window.ga('cibler.send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
      });
    }
  }

  static trackTime(frameName, timer) {
    GA.emitTrackEvent('TIMER', `${frameName}_${timer}`);
  }

  static trackInteraction(frameName, interaction) {
    GA.emitTrackEvent('ACTION', `${frameName}_${interaction}`);
  }

  static addToBasket(product) {
    window.ga('cibler.ecommerce:addProduct', {
      id: product.product_id,
      name: product.name,
      category: product.category,
      brand: product.brand,
      variant: product.variant,
      price: product.price,
      quantity: product.quantity,
    });
    window.ga('cibler.ecommerce:setAction', 'add');
    window.ga('cibler.ecommerce:send');
  }

  static confirmBasket(cart) {
    const transactionId = Utils.generateCiblerId('CIBTRANS1');

    if (!cart) return;

    window.ga('cibler.ecommerce:addTransaction', {
      id: transactionId,
      revenue: cart.orderInformation ? cart.orderInformation.totalSpent : cart.total,
    });

    if (cart.orderInformation && cart.orderInformation.orderLines && cart.orderInformation.orderLines.length) {
      cart.orderInformation.orderLines.forEach((item) => {
        window.ga('cibler.ecommerce:addItem', {
          id: transactionId,
          name: item.name,
          sku: item.product_id,
          price: item.unit_price,
          quantity: item.quantity,
        });
      });
    }

    window.ga('cibler.ecommerce:send');
  }
}
